import { useState } from "react";

export const useResponsiblePanelDate = () => {
    const [cooldown, setCooldown] = useState(false);
    const [cooldownMax, setCooldownMax] = useState("24 hours");
    const [cooldownRemain, setCooldownRemain] = useState("23h 6m");
    const [isModalOpen, setIsModalOpen] = useState(false);

    return {
        cooldown,
        setCooldown,
        cooldownMax,
        setCooldownMax,
        cooldownRemain,
        setCooldownRemain,
        isModalOpen,
        setIsModalOpen
    }
}